import actionCreator from '../../shared/decorators/actionCreator';
import { REDUX_NAMESPACE } from '../constants';

const ACTION_CREATORS = {
  @actionCreator(REDUX_NAMESPACE)
  importCompleted(elementId, contentId, mediaId) {
    return {
      contentId,
      elementId,
      mediaId,
    };
  },
};

export default ACTION_CREATORS;
